export function getMetricDesignOptionsKey(
    measurementName: string,
    aggregateFunction: string
): string {
    return `${measurementName}_${aggregateFunction}`;
}
